export default __webpack_public_path__ + "static/media/dotted-line.9bb4656e.svg";